import { ApolloLink, createHttpLink } from '@apollo/client';


export function httpLink(clientURL: string | undefined): ApolloLink {
  return createHttpLink({
    uri: clientURL,
  });
}
